import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { LiveAnnouncerService } from 'src/app/app-common/services/live-announcer.service';
import { ScrollingListOperation } from 'src/app/components/scrolling-list/page-with-list.component';
import { StorageUtilsService } from '../../services/storage-utils.service';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'storage-list-view',
    templateUrl: './storage-list-view.component.html',
    styleUrls: ['./storage-list-view.component.scss'],
    standalone: false
})
export class StorageListViewComponent implements AfterViewInit {
  @Input() files: any[];
  @Input() folderPath: string = '';
  @Input() filesDetails;
  @Input() fileListVisible;
  @Input() search;
  @Input() selectAll: boolean = false;
  @Input() isEmpty: boolean;
  @Input() listOperations: ScrollingListOperation[];
  @Output() selectAllCheckboxes: EventEmitter<void> = new EventEmitter<void>();
  @Output() fileClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() uploadFiles: EventEmitter<void> = new EventEmitter<void>();
  @Output() operationClick: EventEmitter<{file: any, operationName: string}> = new EventEmitter();

  constructor (
    public storageUtilsService: StorageUtilsService,
    public storageService: StorageService,
    private liveAnnouncerService: LiveAnnouncerService
  ) {}

  ngAfterViewInit(): void {
    const sortBy = this.search?.sortBy ?? 'name';
    const reverse = !!this.search?.reverse;
    const fieldLabel = this.labelMap[sortBy] || sortBy;
    this.announceSort(fieldLabel, reverse ? 'descending' : 'ascending');
  }
  
  triggerFileClick (file) {
    this.fileClick.emit(file);
  }

  triggerFileSelect (file) {
    this.fileSelect.emit(file);
  }

  changeSort (field: string) {
    if (this.search.sortBy === field) {
      this.search.reverse = !this.search.reverse;
    } else {
      this.search.sortBy = field;
    }
    this.announceSort(this.labelMap[field] || field, this.search.reverse ? 'descending' : 'ascending');
  }

  announceSort(fieldLabel: string, direction: 'ascending' | 'descending') {
    this.liveAnnouncerService.announce(`Table sorted by ${fieldLabel}, ${direction} order`);
  }

  get foldersAndFiles() {
    return [
      ...this.storageUtilsService.filterFolders(this.files, this.search, this.storageService.storageFull),
      ...this.storageUtilsService.filterFiles(this.files, this.search, this.storageService.storageFull, true),
    ];
  }
  
  handleOperationClick(operationName: string, file: any) {
    // this.operationClick.emit({file, operationName});
    const operation = this.listOperations.find(operation => operation.name === operationName);
    if (operation) {
      operation.onClick && operation.onClick(false, [file]);
    }
  }

  get labelMap() {
    return {
      'name': 'Name',
      'extension': 'Type',
      'size': 'Size',
      'dateModified': 'Modified'
    };
  }

}